import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { isUserFollowed, followUser, unfollowUser } from 'common/api/GraphApi';
import FollowButton from 'common/components/FollowButton';
import FollowUnfollowButton from 'common/components/FollowUnfollowButton';
import eventEmitter, { EventsTypes } from 'common/services/events/eventEmitter';
import get from 'common/tools/objects/get';

import AuthenticatedLink from '../user/AuthenticatedLink';

class GraphFollowUnfollowUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true, // to avoid showing "follow" status during the loading
      isFollowed: false
    };
  }

  async componentDidMount() {
    const response = await isUserFollowed(this.props.followGraphId);
    this.setState({
      isLoading: false,
      isFollowed: !!get(response.data, [
        'me',
        'user',
        'social',
        'userConnections',
        'followees',
        'edges',
        'length'
      ])
    });
  }

  render() {
    const { user, followLegacyId, followGraphId, buttonSize } = this.props;
    const { isFollowed, isLoading } = this.state;
    const trackingContext = {
      socialActionPlacement: 'standalone'
    };
    if (user.passiveLoginDone && !user.loggedIn) {
      return (
        <FollowButton
          onClick={() => eventEmitter.emit(EventsTypes.LOGIN_REQUEST)}
          type="full"
          size={buttonSize}
        />
      );
    }
    if (
      isLoading ||
      !user.passiveLoginDone ||
      (user.account && followLegacyId === user.account.id)
    ) {
      // This matches twig render in the user-card module
      return (
        <FollowButton
          className="userprofile-hidden"
          disabled
          type="full"
          size={buttonSize}
        />
      );
    }
    return (
      <AuthenticatedLink>
        <FollowUnfollowButton
          isFollowed={isFollowed}
          follow={() => {
            this.setState({ isFollowed: true });
            followUser(followGraphId, trackingContext);
          }}
          unfollow={() => {
            this.setState({ isFollowed: false });
            unfollowUser(followGraphId, trackingContext);
          }}
          unfollowButtonTheme="grey"
          unfollowButtonType="ghost"
          followButtonType="full"
          followButtonTheme="inverse"
          size={buttonSize}
        />
      </AuthenticatedLink>
    );
  }
}

GraphFollowUnfollowUser.propTypes = {
  buttonSize: PropTypes.string,
  followGraphId: PropTypes.string.isRequired,
  followLegacyId: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired
};

GraphFollowUnfollowUser.defaultProps = {
  buttonSize: 'sm'
};

export default GraphFollowUnfollowUser;
